import { render, staticRenderFns } from "./UploaderComponent.vue?vue&type=template&id=333dde07&scoped=true"
import script from "./UploaderComponent.vue?vue&type=script&lang=js"
export * from "./UploaderComponent.vue?vue&type=script&lang=js"
import style0 from "./UploaderComponent.vue?vue&type=style&index=0&id=333dde07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_css-loader@6.11.0_webpack@5.109.2_postcss@8_d337a9d5bbcfbb759141208e4b3c712e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333dde07",
  null
  
)

export default component.exports